export const origin_destination_max_width_class = "max-w-[43ch]";

function getMaxNumberCharsFromClassName(className: string): number {
  const match = className.match(/max-w-([0-9]+)/);
  return match ? Number(match[1]) : 0;
}

export function getOriginDestinationLabel(
  origin: string,
  destination: string,
  variant: "one-way" | "roundtrip"
) {
  const arrow = variant === "roundtrip" ? "↔" : "→";

  // origin can sometimes be very long, and hide the entire destination
  // note that 'ch' is the width of the character '0' in the current font, not the number of characters.
  // expect actual number of characters to not be exactly the calculated amount.
  // Should show minimum of 20 characters of either side (including single char for elipses)
  // 3 is for the arrow + 2 spaces.
  const should_truncate =
    origin?.length + destination?.length >
    getMaxNumberCharsFromClassName(origin_destination_max_width_class) - 3;

  const should_truncate_origin = should_truncate && origin?.length > 19;

  const shortend_origin = should_truncate_origin
    ? `${origin?.slice(0, 19).trim()}…` // trim to avoid having a space before the ellipsis
    : origin;

  return `${shortend_origin} ${arrow} ${destination}`;
}
